<style lang="stylus">
        .searchFunc
            width 312px
            .searchFunc-inputBox
                height 32px
                display flex
                justify-content space-around
                input
                    border none
                    background var(--bg-color-tertiary)
                    padding-left 12px
                    flex 1
                    outline none
                    height 32px
                    border-radius 6px 0 0 6px
                    border 1px solid var(--border-color-ivu-input-number)
                .library-search-go
                    background #fff
                    text-align center
                    width 43px
                    line-height 32px
                    border-radius 0 6px 6px 0
                    cursor pointer
                    user-select none
                    background var(--themeColor)
                    transition background .2s linear
                    svg
                        display inline-block
                        vertical-align middle
                        width 20px
                        height 20px
                    &:hover
                        background var(--themeHover)
            .searchFunc-noResult
                width 100%
                height 78px
                padding-top 18px
                img
                    display block
                    width 42px
                    height 42px
                    margin 0 auto
                    margin-bottom 7px
                p
                    font-size 12px
                    color #9e9e9e
                    text-align center
                    display flex
                    justify-content center
                    align-items center
                    .noResult-text
                        display inline-block
                        max-width 70%
                        overflow hidden
                        text-overflow ellipsis
                        white-space nowrap
            .searchFunc-resultBox
                margin-top 27px
                padding 3px 0
                overflow-y auto
                max-height 400px
                .searchFunc-item
                    display inline-block
                    padding 5px 14px
                    font-size 12px
                    color var(--text-color-primary)
                    background-color var(--bg-color-searchFunc-item)
                    border 1px solid var(--border-color-ivu-input-number)
                    border-radius 3px
                    margin-bottom 10px
                    user-select none
                    cursor pointer
                    transition background-color .2s linear
                    &:not(:last-child)
                        margin-right 10px
                    &:not(.display):hover
                        background-color var(--bg-color-searchFunc-item-hover)
                    &.display
                        cursor not-allowed
    .searchFunc-mask
        .dialog-slot
            @media screen and (max-height: 768px)
                max-height 300px
</style>

<template>
    <div class="searchFunc-mask">
        <Dialog :title="$t('title')" :mask="true" ref="searchDialog" @close="close">
            <div class="searchFunc">
                <div class="searchFunc-inputBox">
                    <input
                        type="text"
                        ref="searchFuncInput"
                        v-model="searchStr"
                        :placeholder="$t('searchSymbol')"
                        @input="resultArr = null"
                        @keyup.enter="search"
                    />
                    <div class="library-search-go" @click="search()">
                        <iconSymbol style="fill: #fff; stroke: #fff" name="searchFunc" />
                    </div>
                </div>

                <div class="searchFunc-noResult" v-if="resultArr && resultArr.length == 0">
                    <img src="@/app/assets/no-result.png" alt="No Result" />
                    <p v-if="lang == 'zh'">
                        <span>{{ $t("noFind") }}</span>
                        <span class="noResult-text" :title="searchStr">{{ searchStr }}</span>
                        <span>{{ $t("noFind2") }}</span>
                    </p>
                    <p v-else>{{ $t("noFind") }}</p>
                </div>

                <div class="searchFunc-resultBox" v-if="resultArr && resultArr.length != 0">
                    <span
                        class="searchFunc-item"
                        :class="{ display: item.type == 'display' }"
                        v-for="(item, index) in resultArr"
                        :key="index"
                        @click="clickTag(item)"
                    >
                        {{ item.name }}
                    </span>
                </div>
            </div>
        </Dialog>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Inject } from "vue-property-decorator";
    import Dialog from "./Dialog.vue";
    import { searchKey } from "@/app/utils/searchFunction.js";
    import appConfig from "@/public/globalConfig";
    enum tabType {
        file,
        edit,
        select,
        insert,
        arrange,
        view,
        help,
        symbol,
    }
    // @Component 修饰符注明了此类为一个 Vue 组件
    @Component({
        components: {
            Dialog,
        },
    })
    export default class SearchFunc extends Vue {
        @Inject()
        ["showMessage"];

        searchFuncInput: any;
        blocker: boolean = false;
        searchStr: string = "";
        resultArr: Array<any> = null;
        workerURL: string = appConfig.workerURL;

        search() {
            if (this.blocker) return;
            this.blocker = true;
            this.searchFuncInput.blur();
            this.resultArr = searchKey(this.lang, this.searchStr) || [];
            setTimeout(() => {
                this.blocker = false;
            }, 200);
            this.$nextTick(() => {
                (<any>this.$refs.searchDialog).resetPosition();
            });
        }
        clickTag(item) {
            if (item.type == "display") return;
            this.close();
            let openTabsMenu = (ref, type) => {
                setTimeout(() => {
                    this.$bus.$emit("showTabsMenu", {
                        ref,
                        type,
                    });
                }, 0);
            };
            let showTips = (type, str) => {
                let ts: any = this;
                let data = this.$t(str);
                if (type == "success") ts.$edMessage.success(data);
                else if (type == "error") ts.$edMessage.error(data);
                else if (type == "warn") ts.$edMessage.warning(data);
            };
            let showHideTip = (type) => {
                let ts: any = this;
                let typeStr = this.$t(type),
                    fullStr = this.$t("hideTip", { type: typeStr });
                ts.$edMessage.warning(fullStr);
                this.activeFunc = "rightPanelSetting";
                return;
            };
            this.activeFunc = item.func;
            // 顶部菜单栏
            if (
                [
                    "backToHome",
                    "fileSaveFile",
                    "fileSaveAs",
                    "fileReName",
                    "fileImportData",
                    "fileOutputData",
                    "fileShareFile",
                    "filePrintFile",
                    "filePageSet",
                    "fileOptions",
                    "fileEncrypt",
                    "fileDownload",
                    "fileStar",
                ].includes(item.func)
            ) {
                openTabsMenu("tabsFile", tabType.file);
            }
            if (
                [
                    "editUndo",
                    "editRedo",
                    "editCut",
                    "editCopy",
                    "editPaste",
                    "editStyleBrush",
                    "editSetDefaultStyle",
                    "editReplace",
                    "editCreateSmartShape",
                ].includes(item.func)
            ) {
                openTabsMenu("tabsEdit", tabType.edit);
            }
            if (
                [
                    "selectAll",
                    "selectAllShapes",
                    "selectAllLines",
                    "selectAllImages",
                    "selectAllGuideLines",
                    "selectByLayer",
                    "selectByShape",
                    "selectByLines",
                    "selectExclude",
                ].includes(item.func)
            ) {
                openTabsMenu("tabsSelect", tabType.select);
            }
            if (
                [
                    "insertNote",
                    "insertComment",
                    "insertHylink",
                    "insertImage",
                    "insertTable",
                    "insertChart",
                    "insertMap",
                    "insertMath",
                    "insertQRCode",
                    "insertWaterMark",
                    "insertAttach",
                    "insertTimeline",
                    "insertContainer",
                ].includes(item.func)
            ) {
                openTabsMenu("tabsInsert", tabType.insert);
            }
            if (
                [
                    "alignMoveTop",
                    "alignMoveBottom",
                    "alignMoveUp",
                    "alignMoveDown",
                    "alignAlign",
                    "alignDistribute",
                    "alignSameSize",
                    "alignLock",
                    "alignUnlockAll",
                    "alignGroup",
                    "alignUngroup",
                ].includes(item.func)
            ) {
                openTabsMenu("tabsArrange", tabType.arrange);
            }
            if (
                [
                    "viewZoomIn",
                    "viewZoomOut",
                    "viewFitToContent",
                    "viewFitToPageWidth",
                    "viewFitToPage",
                    "viewFitToDrawing",
                    "viewGrid",
                    "viewGuides",
                    "viewMargins",
                    "viewRuler",
                    "viewFloatButton",
                    "viewShowLibrary",
                    "viewShowDataSheet",
                    "viewToolbar",
                    "viewMoveCoord",
                    "viewPageBreak",
                ].includes(item.func)
            ) {
                openTabsMenu("tabsView", tabType.view);
            }
            if (
                [
                    "shapeSaveSymbol",
                    "shapeNewLibrary",
                    "shapeOpenLibrary",
                    "shapeNewLibraryFromPictures",
                    "shapeAddTextWidthControlPoint",
                    "shapeAddTextAboveShape",
                    "shapeAddConnectionPointsAutomatically",
                    "shapeRmoveConnectionPoints",
                ].includes(item.func)
            ) {
                openTabsMenu("tabsSymbol", tabType.symbol);
            }
            // 帮助下拉菜单迁移至右上角❓图标
            if (
                ["helpCenter", "helpShortKey", "helpReportError", "helpGuides", "helpVideo", "newFunc", "helpOnlineSupport", "funcTutorial"].includes(
                    item.func
                )
            ) {
                // openTabsMenu('tabsHelp', tabType.help)
                // bus 的 $on 方法先于 $emit 执行
                setTimeout(() => {
                    this.$bus.$emit("showHelpMenu");
                }, 0);
            }
            if (
                ["menuPageSlice", "menuSlide", "menuSaveFile", "menuStarFile", "menuPrintFile", "menuShareFile", "menuOutputFile"].includes(item.func)
            ) {
                // this.activeFunc = item.func;
            }
            // 顶部工具栏
            if (
                ["topMenuFile", "topMenuEdit", "topMenuInsert", "topMenuArrange", "topMenuView", "topMenuSymbol", "topMenuSelect"].includes(item.func)
            ) {
                // this.activeFunc = item.func;
            }
            if (
                [
                    "tabsUndo",
                    "tabsRedo",
                    "tabsBold",
                    "tabsItaly",
                    "tabsUnderline",
                    "tabsFontColor",
                    "tabsFontAround",
                    "tabsFontAlign",
                    "tabsFontOption",
                    "tabsAddText",
                    "tabsConnectLine",
                    "tabsLayout",
                    "tabsLayer",
                    "tabsAlign",
                    "tabsMirror",
                    "tabsGroup",
                    "tabsFillColor",
                    "tabsLineCoor",
                    "tabsLineStyle",
                    "tabsLock",
                    "tabsSpeciaOption",
                    "tabsSetDefaultStyle",
                    "tabsReplace",
                ].includes(item.func)
            ) {
                // TODO: 补充新的工具栏的对应搜索逻辑与菜单
                let map = new Map([
                    ["tabsConnectLine", "connector"],
                    ["tabsLayout", "layout"],
                    ["tabsLayer", "layer"],
                    ["tabsSetDefaultStyle", "theme"],
                    ["tabsAlign", "align"],
                    ["tabsMirror", "mirror"],
                    ["tabsGroup", "compose"],
                    ["tabsLineStyle", "acquiesceStyle"],
                    ["tabsLock", "protect"],
                    ["tabsReplace", "search"],
                ]);
                setTimeout(() => {
                    this.$bus.$emit("openNavigationHiddenTool", map.get(item.func));
                }, 0);
            }
            if (["tabsBeautify", "tabsReplaceClr"].includes(item.func)) {
                if (!this.canReplaceClr && !this.canReplaceFlowClr) {
                    showTips("error", "noShape"); // 可以细化提示：当前页面没有形状
                } else {
                    setTimeout(() => {
                        this.$bus.$emit("openNavigationTool", "autoFormat");
                        this.activeFunc = item.func;
                    }, 0);
                }
            }
            if (
                [
                    "tabsDeleteLine",
                    "tabsFontBgColor",
                    "tabsFontListStyle",
                    "tabsLineHeight",
                    "tabsFirstIndent",
                    "tabsLeftIndent",
                    "tabsRightIndent",
                    "tabsBefore",
                    "tabsAfter",
                ].includes(item.func)
            ) {
                if (!this.isSelect) {
                    showTips("error", "noShape");
                } else {
                    setTimeout(() => {
                        // this.$bus.$emit("openNavigationFontTool", "option");
                    }, 0);
                }
            }
            if (["tabsHMirror", "tabsVMirror", "tabsRotate"].includes(item.func)) {
                if (!this.isSelect) {
                    showTips("error", "noShape");
                } else {
                    setTimeout(() => {
                        this.$bus.$emit("openNavigationTool", "layout");
                    }, 0);
                }
            }
            if (["tabsMoveTop", "tabsMoveBottom", "tabsMoveUp", "tabsMoveDown"].includes(item.func)) {
                if (!this.isSelect) {
                    showTips("error", "noShape");
                } else {
                    setTimeout(() => {
                        this.$bus.$emit("openNavigationTool", "layer");
                    }, 0);
                }
            }
            if (
                [
                    "tabsLineWidth",
                    "tabsArrowStyle",
                    "tabsBorderRadio",
                    "tabsArrowSize",
                    "tabsConnectLineStyle",
                    "tabsConnectorPoint",
                    "tabsConnectorPointStyle",
                ].includes(item.func)
            ) {
                if (!this.isSelect) {
                    showTips("error", "noShape");
                } else {
                    setTimeout(() => {
                        this.$bus.$emit("openNavigationTool", "acquiesceStyle");
                    }, 0);
                }
            }
            // todo：右侧工具栏处于非展示状态时，点击搜索结果进行提示
            let list = localStorage.getItem("rightViewList");
            let hideList = list ? JSON.parse(list) : ["echart", "slideset", "propertyP", "revisions"];
            // 右侧工具栏
            if (
                [
                    "showRightStyle",
                    "showRightPage",
                    "showRightTheme",
                    "showRightLayer",
                    "showRightSlide",
                    "showRightProperty",
                    "showRightImage",
                    "showRightOrgchart",
                    "showRightPlan",
                    "showRightGantt",
                    "showRightMindMaster",
                    "showRightHistory",
                ].includes(item.func)
            ) {
                let map = {
                    // '': 'echart',
                    showRightStyle: "shapeP", // 样式
                    showRightPage: "pageset", // 页面设置
                    showRightTheme: "themeP", // 主题
                    showRightSlide: "slideset", // 文档演示
                    showRightProperty: "propertyP", // 形状数据
                    showRightHistory: "revisions", // 历史版本
                };
                let type = map[item.func];
                if (hideList.includes(type)) {
                    showHideTip(type);
                }
                // this.activeFunc = item.func;
            }
            // 右侧工具栏 -> 样式
            if (["rightStyleFill", "rightStyleLine", "rightStyleShadow"].includes(item.func)) {
                if (hideList.includes("shapeP")) {
                    showHideTip("shapeP");
                } else {
                    this.$bus.$emit("changeRightViewActiveKey", "shapeP");
                    this.$bus.$emit("changeRightView", "shapeP", false, "other");
                }
            }
            // 右侧工具栏 -> 填充
            if (["rightPageBgColor", "rightPageDeleteBg", "rightPageWaterMark"].includes(item.func)) {
                if (hideList.includes("pageset")) {
                    showHideTip("pageset");
                } else {
                    this.$bus.$emit("changeRightViewActiveKey", "pageset");
                    this.$bus.$emit("changeRightView", "pageset", false, "other");
                }
            }
            // if('showRightTable' == item.func){
            //     if(!this.isTableShape){
            //         showTips('error', 'noTable')
            //     }
            //     else{
            //         this.$bus.$emit('changeRightViewActiveKey','tableset');
            //         this.$bus.$emit('changeRightView', 'tableset')
            //     }
            // }
            // if('showRightEChart' == item.func){
            //     if(!this.isTableShape){
            //         showTips('error', 'noEChart')
            //     }
            //     else{
            //         this.$bus.$emit('changeRightViewActiveKey','echart');
            //         this.$bus.$emit('changeRightView', 'echart')
            //     }
            // }
            // if('showRightSmartshape' == item.func){
            //     if(!this.isTableShape){
            //         showTips('error', 'noSmartShape')
            //     }
            //     else{
            //         this.$bus.$emit('changeRightViewActiveKey','layout');
            //         this.$bus.$emit('changeRightView', 'layout')
            //     }
            // }
            // 底部工具栏
            // ['previewPage', 'addPage', 'smallPage', 'bigPage', 'fitPage']

            //符号库
            if (["showLibrary", "showSearchLibrary", "showCollectLibrary"].includes(item.func)) {
                if (!this.showLibrary) {
                    this.showLibrary = true;
                    let ts: any = this;
                    ts.$bus.$emit("toggleLibrary");
                    this.$nextTick(() => {
                        window["_view"].onsize();
                    });
                }
            }
        }
        cleanData() {
            this.searchStr = "";
            this.resultArr = null;
        }
        close() {
            this.cleanData();
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: false,
            });
        }
        get activeFunc() {
            return this.$store.state.ui.activeFunc;
        }
        set activeFunc(v) {
            this.$store.commit("setStatus", {
                type: "activeFunc",
                data: v,
            });
        }
        get isSelect() {
            return !!this.$store.state.shape.isActived;
        }
        get isTableShape() {
            return this.$store.state.shape.type == "Table";
        }
        get showLibrary() {
            return this.$store.state.ui.showLibrary;
        }
        set showLibrary(v) {
            this.$store.commit("setStatus", {
                type: "showLibrary",
                data: v,
            });
        }
        get canReplaceClr() {
            return this.$store.state.ui.canReplaceClr;
        }
        get canReplaceFlowClr() {
            return this.$store.state.ui.canReplaceFlowClr;
        }
        mounted() {
            this.$bus.$emit("closeMenuDrop");
            this.searchFuncInput = this.$refs.searchFuncInput;
            this.$nextTick(() => {
                this.searchFuncInput.focus();
            });
        }
        created() {}
    }
</script>
<i18n>
{
  "zh": {
    "title": "功能查找",
    "searchSymbol": "请输入功能名称",
    "noFind": "未找到",
    "noFind2": "相关功能",
    "noShape": "未选择形状",
    "noTable": "未选择表格",
    "noEChart": "未选择图表",
    "noSmartShape": "未选择smartShape",
    "shapeP": "样式",
    "pageset": "页面设置",
    "themeP": "主题",
    "slideset": "文档演示",
    "propertyP": "形状数据",
    "revisions": "历史版本",
    "hideTip": "右侧面板{type}未打开，请先通过右下角设置打开该面板"
  },
  "en": {
    "title": "Feature Find",
    "searchSymbol": "Input feature name here",
    "noFind": "No results",
    "noFind2": "No related feature found",
    "noShape": "未选择形状",
    "noTable": "未选择表格",
    "noEChart": "未选择图表",
    "noSmartShape": "未选择smartShape",
    "shapeP": "Style",
    "pageset": "Page Settings",
    "themeP": "Theme",
    "slideset": "Slide",
    "propertyP": "Data Property",
    "revisions": "Historical Version",
    "hideTip": "The right panel {type} is not open; please access the settings in the lower right corner and then open this panel."
  },
  "fr": {
    "title": "Recherche de fonction",
    "searchSymbol": "Veuillez saisir un nom de fonction",
    "noFind": "Introuvable",
    "noFind2": "Fonctionnalités Associées",
    "noShape": "Aucune Forme Sélectionnée",
    "noTable": "Aucune Table Sélectionnée",
    "noEChart": "Aucun Graphique Sélectionné",
    "noSmartShape": "smartShape n'est pas sélectionné",
    "shapeP": "Style",
    "pageset": "Paramètres de Page",
    "themeP": "Thème",
    "slideset": "Présentation du document",
    "propertyP": "Propriété de données",
    "revisions": "Version Historique",
    "hideTip": "The right panel {type} is not open; please access the settings in the lower right corner and then open this panel."
  },
  "de": {
    "title": "Suchen",
    "searchSymbol": "Name eingeben",
    "noFind": "Nicht gefunden",
    "noFind2": "Relevante Funktionen",
    "noShape": "Keine Form ausgewählt",
    "noTable": "Keine Tabelle ausgewählt",
    "noEChart": "Kein Diagramm ausgewählt",
    "noSmartShape": "Keine SmartShape ausgewählt",
    "shapeP": "Format",
    "pageset": "Seiteneinstellung",
    "themeP": "Thema",
    "slideset": "Diashow",
    "propertyP": "Dateneigenschaft",
    "revisions": "Historische Version",
    "hideTip": "The right panel {type} is not open; please access the settings in the lower right corner and then open this panel."
  },
  "jp": {
    "title": "機能検索",
    "searchSymbol": "機能の名前を入力してください",
    "noFind": "検索結果なし",
    "noFind2": "類似機能",
    "noShape": "図形なし",
    "noTable": "テーブルなし",
    "noEChart": "チャートなし",
    "noSmartShape": "smartShapeなし",
    "shapeP": "スタイル",
    "pageset": "ページ設定",
    "themeP": "テーマ",
    "slideset": "プレゼンテーション",
    "propertyP": "属性",
    "revisions": "前のバージョン",
    "hideTip": "The right panel {type} is not open; please access the settings in the lower right corner and then open this panel."
  },
  "es": {
    "title": "Búsqueda de características",
    "searchSymbol": "Introduzca el nombre de la característica aquí",
    "noFind": "No hay resultados",
    "noFind2": "No se encontró ninguna característica relacionada",
    "noShape": "No selecciona forma ",
    "noTable": "No selecciona mesa",
    "noEChart": "No selecciona gráfico ",
    "noSmartShape": "No selecciona forma inteligente",
    "shapeP": "Estilo",
    "pageset": "Configuración de la página",
    "themeP": "Tema",
    "slideset": "Diapositiva",
    "propertyP": "Propiedad de los datos",
    "revisions": "Versión histórica",
    "hideTip": "The right panel {type} is not open; please access the settings in the lower right corner and then open this panel."
  },
  "pt": {
    "title": "Encontrar Característica",
    "searchSymbol": "Entrar com o nome da característica aqui",
    "noFind": "Sem resultados",
    "noFind2": "Característica relacionada não encontrada",
    "noShape": "未选择形状",
    "noTable": "未选择表格",
    "noEChart": "未选择图表",
    "noSmartShape": "未选择FormaInteligente",
    "shapeP": "Estilo",
    "pageset": "Configurações de Página",
    "themeP": "Tema",
    "slideset": "Slide",
    "propertyP": "Propriedade de Dados",
    "revisions": "Versão Histórica",
    "hideTip": "The right panel {type} is not open; please access the settings in the lower right corner and then open this panel."
  },
  "it": {
    "title": "Trova Funzioni",
    "searchSymbol": "Digitare il nome della funzione",
    "noFind": "Nessun risultato",
    "noFind2": "Non è stata trovata nessuna funzione",
    "noShape": "Nessuna forma selezionata",
    "noTable": "Nessuna tabella selezionata",
    "noEChart": "Nessun grafico selezionato",
    "noSmartShape": "Nessuna Smart Shape selezionata",
    "shapeP": "Stile",
    "pageset": "Impostazioni Pagina",
    "themeP": "Tema",
    "slideset": "Diapositiva",
    "propertyP": "Proprietà Dati",
    "revisions": "Cronologia Versioni",
    "hideTip": "The right panel {type} is not open; please access the settings in the lower right corner and then open this panel."
  },
  "tw": {
    "title": "功能查找",
    "searchSymbol": "請輸入功能名稱",
    "noFind": "未找到",
    "noFind2": "相關功能",
    "noShape": "未選擇形狀",
    "noTable": "未選擇表格",
    "noEChart": "未選擇圖表",
    "noSmartShape": "未選擇smartShape",
    "shapeP": "樣式",
    "pageset": "主題",
    "themeP": "頁面設置",
    "slideset": "檔案演示",
    "propertyP": "形狀數據",
    "revisions": "歷史版本",
    "hideTip": "The right panel {type} is not open; please access the settings in the lower right corner and then open this panel."
  },
  "kr": {
    "title": "기능 찾기",
    "searchSymbol": "기능명을 입력해주세요",
    "noFind": "찾을 수 없음",
    "noFind2": "관련 기능",
    "noShape": "모양 미선택",
    "noTable": "표 미선택",
    "noEChart": "그래프 미선택",
    "noSmartShape": "smartShape 미선택",
    "shapeP": "스타일",
    "pageset": "페이지 설정",
    "themeP": "주제",
    "slideset": "슬라이드",
    "propertyP": "형상 데이터",
    "revisions": "과거 버전",
    "hideTip": "The right panel {type} is not open; please access the settings in the lower right corner and then open this panel."
  }
}
</i18n>
